<template>
	<section class='knd-header'>
		<div class='knd-header-bg'>
			<div class='knd-constraint-min'>

				<div class='header-animation' ref='animation'>
					<!-- <HeaderImage /> -->
				</div>
				<h1>{{header.title}}</h1>

				<div class='knd-teaser'>
					<p v-html="header.lead"></p>
				</div>
			</div>
		</div>

<!-- 		<div class='knd-constraint knd-header-menu'>
			<div class='knd-header--footer'>
				<HeaderSelect />
			</div>
		</div>
 -->
	</section>
</template>

<script>
	import HeaderSelect from './headerselect';
	import HeaderImage from '@/assets/header-logo.svg?inline';

	import * as lottie from 'lottie-web';
	import animationJson from '@/assets/data/oog_animatie2.json';

	const vueObject = {
		components: {HeaderSelect, HeaderImage},
		data: function() {
			return {
				selected: '0'
			}
		},
		computed: {
			header() { 
				return this.$store.state.data.landing;
			}
		},	
		mounted() {
			this.setLottie();
		},

		methods: {

			setLottie(){			
				let animation = lottie.loadAnimation({
					container: this.$refs.animation, // the dom element that will contain the animation
					renderer: 'svg',
					loop: true,
					autoplay: true,
					animationData: animationJson // the path to the animation json
				});

				animation.addEventListener('data_failed', err => {
					console.error('Lottie Animation failed:', { errMsg: err.message })
				})
			}
		}
	}

	export default vueObject;
</script>